import React, { useState } from "react"
import axios from "axios"
import { useStaticQuery, graphql } from "gatsby"

import { useTranslation } from "react-i18next"

import "§/src/components/contact-modal/_index.scss"

const ModalRight = React.lazy(() =>
  import("§/src/components/atoms/content/modal-right")
)

const ContactForm = React.lazy(() => import("./contact-form"))

const ContactModal = props => {
  const { t } = useTranslation()

  const formLinks = useStaticQuery(graphql`
    query FormLinks {
      globalFormLinks: wp {
        acfoptGlobalOptions {
          acfGlobal {
            privacyPolicyLink
            termsAndConditionsLink
          }
        }
      }
    }
  `)

	const msgs = {
		fill: props.msg?.fill || t("Ti invitiamo a compilare il form sottostante per ricevere informazioni più dettagliate. Un tecnico Gefran ti contatterà molto presto."),
		submit: props.msg?.submit || t("Thanks for contacting us! We will get in touch with you shortly."),
	};

  const [submitted, setSubmitted] = useState(false)

  const onFormSubmit = async data => {
    let formId = 2;

    try {
      const response = await axios.post(
        `https://contacti.kinsta.cloud/wp-json/gf/v2/forms/${formId}/submissions`,
        data
      )
      if (!!response && !!response.data && !!response.data.is_valid) {
        setSubmitted(true)
      } else {
        console.error(`Contact form error: ${JSON.stringify(response.data)}`)
      }
    } catch (e) {
      console.error(JSON.stringify(e))
    }
  }

  return (
    <div>
      <ModalRight modalid={props?.modalid}>
        <h3 className="contact-modal__title">
          {props?.modalTitle || t("Informazioni sul prodotto")}
        </h3>
        <p className="mb-4">
          { submitted ? msgs.submit : msgs.fill }
        </p>
        <div
          className="d-flex flex-row align-items-center justify-content-end"
          style={{ marginBottom: "3.75rem" }}
        >
          {!submitted && (
            <span className="contact-modal__required-label">
              {t("*campi obbligatori")}
            </span>
          )}
        </div>
        {!submitted && (
          <ContactForm
            country={props.country}
            pageTitle={props.pageTitle}
						requestType={props.requestType}
            onSubmit={onFormSubmit}
            formLinks={formLinks}
          ></ContactForm>
        )}
      </ModalRight>
    </div>
  )
}

export default ContactModal
